<template>
  <div class="detail">
	  
<div class="detail-head clear-fix">
      <div class="fl disFlex">
        <div class="w100">
          <img :src="picture" width="180" height="180" alt="">
        </div>
        <div class="flex1">
          <p class="font18">{{topData.nickName}}</p>
          <p class="mt10">{{topData.selfIntr}}</p>
        </div>
      </div>

      <div class="fr">
        <ul class="detail-head-content">
          <li>
            <p class="font22">{{topData.numberOfFans}}</p>
            <p>粉丝数</p>
          </li>
          <li>
            <p class="font22">{{topData.praisePoints}}</p>
            <p>获得的点赞数</p>
          </li>
          <li>
            <p class="font22">{{topData.commentNumber}}</p>
            <p>获得的评论数</p>
          </li>
        </ul>
      </div>
    </div>
	
	<!-- begin -->
	<div class="minW1060-auto bg-fff mag10 pad10">
	  <el-row class="text-left">
			
	    <div class="dlblock-mb20 mr10">
	      <span class="pr5">单词</span>
	      <el-input v-model.trim="word" placeholder="请输入" style="width: 150px;"/>
	    </div>
	
	   <div class="dlblock-mb20 mr10">
	      <span class="pr5">翻译</span>
	      <el-input v-model.trim="chinese" placeholder="请输入" style="width: 150px;"/>
	    </div>
		  
		  <div class="dlblock-mb20 mr10">
		    <span class="pr5">创建时间</span>
		    <el-date-picker
		        v-model="date"
		        style="width: 300px;"
		        type="daterange"
		        value-format="yyyy-MM-dd"
		        range-separator="至"
		        start-placeholder="开始日期"
		        end-placeholder="结束日期"/>
		  </div>
		  
	    <div class="dlblock-mb20 mr10">
	      <el-button type="primary" @click="pages.page = 1; getEnWordPackageItemFn()">
	        搜索
	      </el-button>
	    </div>
	    <div class="dlblock-mb20">
		  <el-button type="primary" @click="editBtn(6)">
		    单词列表
		  </el-button>
	    </div>
	  </el-row>
	
	  <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
	    <el-table-column align="center" prop="enWordId" label="单词编号"></el-table-column>
		<el-table-column align="center" prop="word" label="单词"></el-table-column>
	    <el-table-column align="center" prop="chinese" label="中文"></el-table-column>
		  
		  <el-table-column align="center"  label="图片">
		    <template slot-scope="{row}">
		      <el-image class="m-box-img" :src="row.picture" @click="editBtn(3,row)" lazy></el-image>
		    </template>
		  </el-table-column>
		  
	    <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	    <el-table-column align="center" width="150" label="操作">
	      <template slot-scope="{row}">
			  <a class="glob-a"  @click="editBtn(7, row)">修改</a>
	           <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
			   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
	      </template>
	    </el-table-column>
	  </el-table>
	
	  <div class="my-pagination">
	    <el-pagination background layout="total, prev, pager, next" :total="pages.total"
	                   :current-page="pages.page" @current-change="pageChange">
	    </el-pagination>
	  </div>
		
	  <!-- 查看 -->
	  <el-dialog title="查看单词详情" :visible.sync="auditShow.modal" width="800px">
	    <el-form label-width="120px">
	      <el-row>
	        <el-col :span="12">
	          <el-form-item label="单词：">
	            {{auditShow.data.word}}
	          </el-form-item>
	        </el-col>
	        <el-col :span="12">
	          <el-form-item label="翻译：">
	            {{auditShow.data.chinese}}
	          </el-form-item>
	        </el-col>
	      </el-row>
	      <el-row>
	        <el-col :span="12">
	          <el-form-item label="创建时间：">
	            {{auditShow.data.create_time}}
	          </el-form-item>
	        </el-col>
	      </el-row>
			
			<el-row>
			  <el-col :span="12">
			    <el-form-item label="图片：">
					  <el-image class="m-box-img" :src="auditShow.data.picture"  @click="editBtn(4)" lazy></el-image>
			    </el-form-item>
			  </el-col>
			</el-row>
	    </el-form>
	  </el-dialog>
	
	
	<!-- 列表 -->
	<el-dialog title="单词列表" :visible.sync="auditShowList.modal" width="90%">
	  <div class="minW1060-auto bg-fff mag10 pad10">
	    <el-row class="text-left">
	  		
	      <div class="dlblock-mb20 mr10">
	        <span class="pr5">单词</span>
	        <el-input v-model.trim="word" placeholder="请输入" style="width: 150px;"/>
	      </div>
	  
	     <div class="dlblock-mb20 mr10">
	        <span class="pr5">翻译</span>
	        <el-input v-model.trim="chinese" placeholder="请输入" style="width: 150px;"/>
	      </div>
	  	  
	  	  <div class="dlblock-mb20 mr10">
	  	    <span class="pr5">创建时间</span>
	  	    <el-date-picker
	  	        v-model="date"
	  	        style="width: 300px;"
	  	        type="daterange"
	  	        value-format="yyyy-MM-dd"
	  	        range-separator="至"
	  	        start-placeholder="开始日期"
	  	        end-placeholder="结束日期"/>
	  	  </div>
	  	  
	      <div class="dlblock-mb20 mr10">
	        <el-button type="primary" @click="pages.page = 1; getEnWordPageFn()">
	          搜索
	        </el-button>
	      </div>
	      <div class="dlblock-mb20">
	        <el-button type="primary" @click="editBtn(1)">
	          新增
	        </el-button>
	      </div>
	    </el-row>
	  
	    <el-table class="my-table" :data="tableWordData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
	      <el-table-column align="center" prop="word" label="单词"></el-table-column>
	      <el-table-column align="center" prop="chinese" label="翻译"></el-table-column>
	  	  
	  	  <el-table-column align="center"  label="礼物图片">
	  	    <template slot-scope="{row}">
	  	      <el-image class="m-box-img" :src="row.picture" @click="editBtn(3,row)" lazy></el-image>
	  	    </template>
	  	  </el-table-column>
	  	  
	      <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>
	  	   <el-table-column align="center" prop="del_flag" label="音频"></el-table-column>
	      <el-table-column align="center" width="150" label="操作">
	        <template slot-scope="{row}">
				<a class="glob-a"  @click="addSubBtn(7, row)">加入包</a>
	          <a class="glob-a"  @click="editBtn(2, row)">修改</a>
	          <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
	  		   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
	        </template>
	      </el-table-column>
	    </el-table>
	  
	    <div class="my-pagination">
	      <el-pagination background layout="total, prev, pager, next" :total="subPages.total"
	                     :current-page="subPages.page" @current-change="subPageChange">
	      </el-pagination>
	    </div>
	  
	    <!-- 查看 -->
	    <el-dialog title="查看" :visible.sync="auditShow.modal" width="800px">
	      <el-form label-width="120px">
	        <el-row>
	          <el-col :span="12">
	            <el-form-item label="单词：">
	              {{auditShow.data.word}}
	            </el-form-item>
	          </el-col>
	          <el-col :span="12">
	            <el-form-item label="翻译：">
	              {{auditShow.data.chinese}}
	            </el-form-item>
	          </el-col>
	        </el-row>
	        <el-row>
	          <el-col :span="12">
	            <el-form-item label="创建时间：">
	              {{auditShow.data.create_time}}
	            </el-form-item>
	          </el-col>
	        </el-row>
	  		
	  		<el-row>
	  		  <el-col :span="12">
	  		    <el-form-item label="图片：">
	  				  <el-image class="m-box-img" :src="auditShow.data.picture"  @click="editBtn(4)" lazy></el-image>
	  		    </el-form-item>
	  		  </el-col>
	  		</el-row>
	      </el-form>
	    </el-dialog>
	  	
	  	<!-- 图片放大 -->
	  	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	  	</el-dialog>
	  	
	  </div>	
	</el-dialog>
		
	<!-- 新增编辑 -->
	  <el-dialog :title="subEditData.add === 1 ? '新增' : '编辑'" :visible.sync="subEditData.modal" width="500px">
	    <el-form label-width="120px">
	      <el-form-item label="单词：">
	        <el-input v-model.trim="subEditData.name" placeholder="请输入单词"/>
	      </el-form-item>
	      <el-form-item label="图片：">
				<el-row>
				  <word-package-img class="mr10 mb10" v-model="subEditData.picture" :total="1"/>
				</el-row>
	      </el-form-item>
			<el-form-item label="简介：">
			  <el-input v-model.trim="subEditData.introduce" placeholder="请输入简介"/>
			</el-form-item>
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="subEditData.modal = false">取 消</el-button>
	      <el-button type="primary" @click="addBtn">确 定</el-button>
	    </div>
	  </el-dialog>
		
		<!-- 图片放大 -->
		<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
		  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
		</el-dialog>
		
		
		<!-- 新增编辑单词 -->
		  <el-dialog :title="editData.add === 1 ? '新增单词' : '编辑单词'" :visible.sync="editData.modal" width="500px">
		    <el-form label-width="120px">
		      <el-form-item label="单词：">
		        <el-input v-model.trim="editData.word" placeholder="请输入单词"/>
		      </el-form-item>
		      <el-form-item label="翻译：">
		        <el-input v-model.trim="editData.chinese" placeholder="请输入翻译"/>
		      </el-form-item>
		      <el-form-item label="图片：">
					<el-row>
					  <word-img class="mr10 mb10" v-model="editData.picture" :total="1"/>
					</el-row>
		      </el-form-item>
		    </el-form>
		
		    <div slot="footer">
		      <el-button @click="editData.modal = false">取 消</el-button>
		      <el-button type="primary" @click="addBtn">确 定</el-button>
		    </div>
		  </el-dialog>
		  
	</div>
	<!-- end -->
	
  </div>
</template>

<script>
  import {getEnWordPackageItem,
		  getEnWordPage,
		  addOrEditWordform,
		  saveOrEditEnWordRePackage,
		  removeEnWordRePackage,
		  getEnWordPackageDetail,
		  getUserMsg} from '@/api'
  import WordImg from '@/components/WordImg.vue'
  export default {
    name: 'Detail',
	components: {WordImg},
    props: ['id'],
    data () {
      return {
		  //包名称
		  title:"",
		  //包图片
		  picture:"",
		  //单词新增和修改
		  editData: {
		    modal: false,
		    userId: '',
		    add: 1,
		    word: '',
		    chinese: '',
		    picture: []
		  },
        topData: {},
        bottomData: {
          userInvInfoItemDTOList: []
        },
		word:'',
		chinese:'',
		date: '',
		userName: '',
		//单词包里的关联单词列表
		tableData: [],
		//单词包详情里的单词列表
		tableWordData: [],
		tableLoading: false,
		auditData: {
		  modal: false,
		  data: {},
		  type: 'PASS',
		  content: ''
		},
		auditShow: {
		  modal: false,
		  data: {}
		},
		auditShowList: {
		  modal: false,
		  data: {}
		},
		//单词新增和修改
		subEditData: {
		  modal: false,
		  userId: '',
		  add: 1,
		  name: '',
		  introduce: '',
		  picture: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		//分页
		pages: {
		  page: 1,
		  total: 0
		},
		//sub分页
		subPages: {
		  page: 1,
		  total: 0
		},
      }
    },
    created () {
	  this.refresh()
	},
    watch: {
      id () {
        this.refresh()
      }
    },
    methods: {
      refresh () {
		  this.getEnWordPackageItemFn();
		  //当前包详情
		  this.getEnWordPackageDetailFn();
      },
	  removeEnWordRePackageFn (id) {
	    this.tableLoading = true
	    removeEnWordRePackage(id).then(res => {
	     this.$message.success(res.msg)
		 this.getEnWordPackageItemFn();
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  getEnWordPageFn () {
	    this.tableLoading = true
	    getEnWordPage({
	      pageNum: this.subPages.page,
	      startTime: this.date && this.date.length ? this.date[0] : '',
	      endTime: this.date && this.date.length > 1 ? this.date[1] : '',
	      word: this.word,
	      chinese: this.chinese
	    }).then(res => {
	      this.tableWordData = res.data.list
	      this.subPages.total = res.data.count
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  editBtn(t,row) {
	  	  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6列表 7加入包 8 单词包中关联的单词修改
	  	  if(t == 1){
	  		 this.editData = {
	  		   modal: true,
	  		   userId: '',
	  		   add: 1,
	  		   word: '',
	  		   chinese: '',
	  		   picture: []
	  		 }
	  	  }else if(t == 2){
	  		  this.editData = {
	  		    modal: true,
	  		    id: row.id,
	  		    add: 2,
	  		    word: row.word,
	  		    chinese: row.chinese,
	  		    picture: row.picture==null ? [] : [row.picture]
	  		  }
	  	  }else if(t == 3) {
	        this.imgPreData = {
	          modal: true,
	          url: row.picture
	        }
	      }else if(t == 4) {
	        this.imgPreData = {
	          modal: true,
	          url: this.auditShow.data.picture
	        }
	      }else if(t == 5){
	  		this.$confirm(`确认要删除吗`, '提示', {
	  		    confirmButtonText: '确定',
	  		    cancelButtonText: '取消',
	  		    type: 'warning'
	  		  }).then(() => {
	  			 let id = [row.id]
	  		     this.removeEnWordRePackageFn(id);
	  		});	
	  	}else if(t == 6){
			this.auditShowList = {
			  modal: true,
			  data: {}
			}
			this.getEnWordPageFn();
		}else if(t == 7){
			console.info("单词包下关联单词",row)
			this.editData = {
			modal: true,
			id: row.enWordId,
			add: 2,
			word: row.word,
			chinese: row.chinese,
			picture: row.picture==null ? [] : [row.picture]
			}
			
		}
	  },
	addBtn (t) {
	  if (this.editData.add == 1) {
	    addOrEditWordform({
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.msg)
	      this.getEnWordPageFn()
	    })
	  } else {
	    addOrEditWordform({
	      id: this.editData.id,
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.msg)
	      this.getEnWordPageFn()
	    })
	  }
	},
	  addSubBtn (t,row) {
	    if (t == 7) {
	      saveOrEditEnWordRePackage({
			wordPackageId:this.id,
			enWordId:row.id
	      }).then(res => {
	        this.editData.modal = false
	        this.$message.success(res.msg)
	        this.getEnWordPackageItemFn()
	      })
	    } 
	  },
	  getEnWordPackageItemFn(){
	  this.tableLoading = true
	  getEnWordPackageItem({
	    pageNum: this.pages.page,
	    startTime: this.date && this.date.length ? this.date[0] : '',
	    endTime: this.date && this.date.length > 1 ? this.date[1] : '',
		word: this.word,
		chinese: this.chinese,
	    id: this.id
	  }).then(res => {
	    this.tableData = res.data.records
	    this.pages.total = res.data.total
	  }).finally(() => {
	    this.tableLoading = false
	  })
	  },getEnWordPackageDetailFn:function(){
			 //单词包详情
			 getEnWordPackageDetail({id:this.id}).then(res => {
			  //单词包名
			  let packageName = res.data.name
			  let picture = res.data.picture
			  this.title = packageName
			  this.picture = picture
			  //uni.setNavigationBarTitle({ title:packageName });
			 }).finally(() => {
			 })
		 },
	  pageChange (val) {
	    this.pages.page = val
	    this.getEnWordPackageItemFn()
	  },
	  subPageChange (val) {
	    this.subPages.page = val
	    this.getEnWordPageFn()
	  },	
	  uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	}
    }
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 70px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }

  .detail-content {
    padding: 0 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .production {
    border-bottom: 1px solid #ebeef5;
    padding: 5px;
  }

  .production-title {
    position: relative;
    display: inline-block;
    color: #000;
  }

  .production-title > span {
    position: absolute;
    right: -70px;
    top: 0;
    padding: 1px 10px;
    border: 1px solid #8b8d92;
    border-radius: 10px;
    font-size: 12px;
  }

  .production-time {
    color: rgb(148, 148, 148);
    font-size: 12px;
    line-height: 30px;
  }

  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
</style>
